/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomEmailSettings200ResponseSettingsBasicAuth
 */
export interface GetCustomEmailSettings200ResponseSettingsBasicAuth {
    /**
     * 
     */
    user: string;
    /**
     * 
     */
    password: string;
}

/**
 * Check if a given object implements the GetCustomEmailSettings200ResponseSettingsBasicAuth interface.
 */
export function instanceOfGetCustomEmailSettings200ResponseSettingsBasicAuth(value: object): value is GetCustomEmailSettings200ResponseSettingsBasicAuth {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSON(json: any): GetCustomEmailSettings200ResponseSettingsBasicAuth {
    return GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsBasicAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomEmailSettings200ResponseSettingsBasicAuth {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'],
        'password': json['password'],
    };
}

export function GetCustomEmailSettings200ResponseSettingsBasicAuthToJSON(json: any): GetCustomEmailSettings200ResponseSettingsBasicAuth {
    return GetCustomEmailSettings200ResponseSettingsBasicAuthToJSONTyped(json, false);
}

export function GetCustomEmailSettings200ResponseSettingsBasicAuthToJSONTyped(value?: GetCustomEmailSettings200ResponseSettingsBasicAuth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'password': value['password'],
    };
}

